import { RestrictPeriod } from 'domains/models/service_restrict/restrictPeriod';
import { z } from 'zod';

export const RestrictPeriodEnum = z.nativeEnum(RestrictPeriod);
